"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableKeyValue = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const types_1 = require("./types");
require("@veeam/components/lib/StackView/types");
const Cell = react_1.default.memo((_a) => {
    var { children } = _a, stackViewProps = __rest(_a, ["children"]);
    return react_1.default.createElement(components_1.StackView, Object.assign({}, stackViewProps), children);
});
const TableKeyValue = ({ header, items = [], columnHorizontalGap = components_1.INDENT.xl, columnVerticalGap = components_1.INDENT.s, }) => {
    var _a, _b;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("table", { "data-selector-id": "table", cellPadding: 0, cellSpacing: 0 },
            header && (react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(Cell, { distribution: (_a = header === null || header === void 0 ? void 0 : header.labelAlign) !== null && _a !== void 0 ? _a : types_1.TABLE_CELL_ALIGN.start, spaceRight: columnHorizontalGap, spaceBottom: columnVerticalGap },
                            react_1.default.createElement(components_1.Text, { weight: components_1.TEXT_WEIGHT.bold, "data-selector-id": "table-header-cell-label" }, header.label))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(Cell, { distribution: (_b = header === null || header === void 0 ? void 0 : header.valueAlign) !== null && _b !== void 0 ? _b : types_1.TABLE_CELL_ALIGN.start, spaceBottom: columnVerticalGap },
                            react_1.default.createElement(components_1.Text, { weight: components_1.TEXT_WEIGHT.bold, "data-selector-id": "table-header-cell-value" }, header.value)))))),
            react_1.default.createElement("tbody", null, items
                .filter((item) => !item.hidden)
                .map(({ id, label, value, labelAlign = types_1.TABLE_CELL_ALIGN.start, valueAlign = types_1.TABLE_CELL_ALIGN.start, iconSrc, }, idx) => {
                const isLastItem = items.length - 1 === idx;
                return (react_1.default.createElement("tr", { key: id || idx, "data-selector-id": `table-row-id-${id || idx}` },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(Cell, { distribution: labelAlign, spaceRight: columnHorizontalGap, spaceBottom: !isLastItem ? columnVerticalGap : undefined },
                            react_1.default.createElement(components_1.StackView, { gap: components_1.STACK_GAP.s },
                                iconSrc && (react_1.default.createElement(components_1.Icon, { "data-selector-id": "table-cell-icon-label", src: iconSrc })),
                                react_1.default.createElement(components_1.Text, { "data-selector-id": "table-cell-label" }, label)))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(Cell, { distribution: valueAlign, spaceBottom: !isLastItem ? columnVerticalGap : undefined },
                            react_1.default.createElement(components_1.Text, { "data-selector-id": "table-cell-value" }, value !== null && value !== void 0 ? value : '')))));
            })))));
};
exports.TableKeyValue = TableKeyValue;
exports.TableKeyValue.displayName = 'TableKeyValue';
//# sourceMappingURL=TableKeyValue.js.map